<template>
  <section class="intro-section">
    <div class="container">
      <div class="section-header">
        <!-- <h2>医院简介</h2> -->
        <!-- <p>成都北新医院是一所二级乙等综合性医院</p> -->
      </div>
      <div class="intro-content">
        <div class="intro-text">
          <h3>关于我们</h3>
          <p class="text-indent" v-for="value in info?.home_aboutus" :key="value">{{ value }}</p>
            
          <router-link to="/about-us">
            <button class="btn-outline">了解更多</button>
          </router-link>
        </div>
        <div class="intro-image">
          <img class="image-placeholder" src="/Environment/全院/1.png" alt="医院图片">
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">

interface IntroType {
  home_aboutus?: string[];
}

interface SectionProps {
  info?: IntroType;
}
withDefaults(defineProps<SectionProps>(), {});
</script>


<style scoped>
.btn-outline,
.btn-small {
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}


.btn-outline {
  background-color: transparent;
  color: #1a5fb4;
  border: 2px solid #1a5fb4;
}

.btn-outline:hover {
  background-color: #1a5fb4;
  color: white;
}

.btn-small {
  padding: 8px 20px;
  font-size: 0.9rem;
  display: inline-block;
  text-decoration: none;
  text-align: center;
}

a.btn-small {
  color: inherit;
  text-decoration: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-content h2 {
    font-size: 2rem;
  }
}
/* 内容区域通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #1a5fb4;
  margin-bottom: 15px;
}

.section-header p {
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* 医院介绍 */
.intro-section {
  padding: 80px 0;
  background-color: white;
}

.intro-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;
}

.intro-text h3 {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 20px;
}

.intro-text p {
  margin-bottom: 20px;
  line-height: 1.6;
  color: #555;
}

.image-placeholder {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 平板端适配 */
@media (max-width: 1024px) {
  .intro-section {
    padding: 60px 0;
  }
  
  .intro-content {
    gap: 40px;
  }
  
  .intro-text h3 {
    font-size: 1.6rem;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .intro-section {
    padding: 50px 0;
  }
  
  .container {
    padding: 0 15px;
  }
  
  .intro-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .intro-text h3 {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }
  
  .intro-text p {
    margin-bottom: 15px;
    font-size: 0.95rem;
  }
  
  .image-placeholder {
    height: 250px;
  }
  
  .btn-outline {
    width: 100%;
    padding: 12px 20px;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .intro-section {
    padding: 40px 0;
  }
  
  .container {
    padding: 0 10px;
  }
  
  .intro-text h3 {
    font-size: 1.3rem;
  }
  
  .intro-text p {
    font-size: 0.9rem;
  }
  
  .image-placeholder {
    height: 200px;
  }
}
</style>